module.exports = {
  src: __webpack_public_path__ + "assets/images/burger-icon.24b26eab6b587e8e.svg",
  width: 19,
  height: 13,
  toString: function() { return __webpack_public_path__ + "assets/images/burger-icon.24b26eab6b587e8e.svg"; }
};